export default [
  {
    path: '/fruitDayWednesday/index',
    meta:{
      title: '周三水果日'
    },
    component: (resolve) => require(['@/pages/fruitDayWednesday/index'], resolve)
  },
]